interface MarketingVideoProps {
  src: string;
  poster?: string;
  title: string;
  className?: string;
  preload?: "none" | "metadata";
}

export function MarketingVideo({
  src,
  poster,
  title,
  className,
  preload = "metadata",
}: MarketingVideoProps) {
  return (
    <video
      className={className}
      poster={poster}
      title={title}
      aria-label={title}
      controls
      playsInline
      preload={preload}
    >
      <source src={src} type="video/mp4" />
    </video>
  );
}
